import { Component, Input, OnInit } from '@angular/core';
import { YOUTUBE_EMBED_FLAGS_PARAMS } from 'src/app/pages/tabs/learn/helper/article-helper';

@Component({
  selector: 'app-article-content',
  templateUrl: './article-content.component.html',
  styleUrls: ['./article-content.component.scss'],
})
export class ArticleContentComponent implements OnInit {

  @Input() contents: any = [];
  youtubeEmbedParms = YOUTUBE_EMBED_FLAGS_PARAMS;

  constructor() { }

  ngOnInit() { }

}
